import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { Menubar, MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { filter } from 'rxjs';
import { DrawerModule } from 'primeng/drawer';
import { BreadcrumbModule } from 'primeng/breadcrumb';

import { ConfigStore } from '../../store/config.store';
import { Location } from '@angular/common';
@Component({
  selector: 'app-header',
  imports: [
    MenubarModule,
    InputTextModule,
    ReactiveFormsModule,
    IconFieldModule,
    InputIconModule,
    DrawerModule,
    RouterLink,
    BreadcrumbModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  breadcrumbItems: MenuItem[] = [];
  home: MenuItem | undefined;
  location = inject(Location);
  configStore = inject(ConfigStore);
  BACKOFFICE_URL = this.configStore.config()?.API_URL;

  menuItems: MenuItem[] = [
    {
      label: 'Home',
      routerLink: '/home',
      state: {
        source: 'header',
      },
    },
    {
      label: 'Mappa',
      routerLink: '/map',
    },
    // { label: 'Dipendenza', routerLink: '/dipendenza' },
    // { label: 'Attività', routerLink: '/attivita' },
    { label: 'News', routerLink: '/news' },

    // { label: 'Contatti', routerLink: '/contatti' },
  ];

  searchForm: FormGroup = new FormGroup({
    search: new FormControl(''),
  });

  ngOnInit() {
    // mi sottoscrivo all'evento di cambio rotta per aggiornare la classe css del menu e il breadcrumb
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.menuItems = this.menuItems.map((item) => ({
          ...item,
          styleClass: event.urlAfterRedirects.includes(item.routerLink || '')
            ? 'active-item'
            : '',
        }));

        // svuoto il breadcrumbItems
        this.breadcrumbItems = [];

        let route = this.activatedRoute;
        // questo while serve a scendere all'ultima route disponibile nell'alberatura delle route. Esempio: /news/detail/news1 con questo while tornerà l'oggetto route di news1 invece che della sola route news del primo livello dell'alberatura
        while (route.firstChild) {
          route = route.firstChild;
        }

        // se la route ha dei dati (caratteristica di /news e /attivita ad esempio), allora aggiungo al breadcrumbItems la label della route includendo la home
        if (Object.keys(route.snapshot.data).length) {
          this.breadcrumbItems = [{ label: 'Home', routerLink: '/home' }];
          this.breadcrumbItems = [
            ...this.breadcrumbItems,
            ...Object.entries(route.snapshot.data).map(([key, value]) => {
              return { label: value, routerLink: '/' + value.toLowerCase() };
            }),
          ];
          this.breadcrumbItems.at(-1)!.routerLink = '';
        }
      });
  }

  @ViewChild('menubar') menubar!: Menubar;
  isMenubarDrawerVisible: boolean = false;

  ngAfterViewInit() {
    // sostituisco il burger menu del menubar di primeng (che di default appare sotto i 1024px) per aggiungere un evento al click che apra il mio drawer custom
    const burgerMenu: HTMLElement =
      this.menubar.el.nativeElement.querySelector('.p-menubar-button');
    const newBurgerMenu = burgerMenu.cloneNode(true);
    newBurgerMenu.addEventListener('click', () => {
      this.isMenubarDrawerVisible = true;
    });
    burgerMenu.replaceWith(newBurgerMenu);
  }

  redirectToUserArea() {
    window.open(this.BACKOFFICE_URL, '_blank', 'noopener');
  }
}
